import { Grid, Typography } from "@mui/material"
import { IOrderPrint } from "../../../models/OrderManagement"

type IProps = {
    data: IOrderPrint
}

const BasicPrintLeadsHeader = ({data}: IProps) => {

    return (
        <>
            <Grid item md={6} display="flex">
                <Grid>
                    <Grid className="table-header-header">
                        <Typography >{data.dealerContact.name}</Typography>
                    </Grid>
                    <Grid>
                        <Typography >{data.dealerContact.address1}</Typography>
                    </Grid>
                    <Grid>
                        <Typography >{data.dealerContact.city + ", " + data.dealerContact.state + " " + data.dealerContact.zipCode + " " + data.dealerContact.country}</Typography>
                    </Grid>
                    <Grid sx={{mt:1}}>
                        <Typography><b>Dealer ID:</b> {data.dealerContact.customerID}</Typography>
                        <Typography ><b>LEAD #:</b> {data.leads.orderNumber}</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item md={6} display="flex" justifyContent="flex-end">
                <Grid>
                    <Typography ><b>Name:</b> {data.leads.firstName + " " + data.leads.lastName}</Typography>
                    <Typography>{data.leads.address.addressLine1 + " " + data.leads.address.addressLine2}</Typography>
                    <Typography>
                        {data.leads.address.city && data.leads.address.state && (
                            <>
                            {data.leads.address.city + ", " + data.leads.address.state + " " }
                            </>
                        )}
                        { data.leads.address.zipCode + ", " + data.leads.address.country }
                    </Typography>
                    <Grid sx={{mt:1}}>
                        <Typography><b>Email:</b> {data.leads.email}</Typography>
                    </Grid>
                    <Grid >
                        <Typography><b>Phone:</b> {data.leads.phone}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}


export default BasicPrintLeadsHeader